import { render, staticRenderFns } from "./fourGrids.vue?vue&type=template&id=54f13fba&scoped=true&"
import script from "./fourGrids.vue?vue&type=script&lang=js&"
export * from "./fourGrids.vue?vue&type=script&lang=js&"
import style0 from "./fourGrids.vue?vue&type=style&index=0&id=54f13fba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f13fba",
  null
  
)

export default component.exports